import {Component}              from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PaymentService}         from '@src/app/core/services/payment.service';
import {AuthService}            from '@src/app/core/services/auth.service';
import {Breadcrumb}             from '@src/app/shared/models/breadcrumb.model';
import {Button}                 from '@src/app/shared/models/button.model';
import {RolesService}           from '../services/roles.service';

@Component({
    standalone: false,
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss']
})
export class SettingsComponent
{
    public breadcrumbs: Breadcrumb[] = [
        {
            title: 'Home',
            url: '/app/',
            active: false
        },
        {
            title: 'Settings',
            active: true
        },
    ];
    public buttons: Button[] = [
        {
            type: 'button',
            material: 'flat',
            color: 'primary',
            title: 'View Purchase History',
            permission: 'view_credit_logs',
            callback: () => {
                this.paymentService.getCustomerPortal().subscribe(res => {
                    console.log(res);
                    window.location.href = res.data.billing_portal_url;
                });
            }
        },
    ];

    public activeRole = null;
    public selectedTab = 0;
    public tenantId: string;

    constructor(
        private roleService: RolesService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private paymentService: PaymentService,
        private authService: AuthService,
    )
    {
        this.roleService.role.subscribe(result => {
            this.activeRole = result;
        });

        this.activatedRoute.params.subscribe(res => {
            if (res.id) {
                const tab = Number(res.id);
                this.selectedTab = Number.isNaN(tab) ? 0 : tab;
            }
        });
        this.tenantId = this.authService.tenant?.id;
    }

    public changeTab(tabIndex)
    {
        this.router.navigate(['app', 'settings', tabIndex]);
    }
}
